import { createReducer, on } from '@ngrx/store';
import * as IotThingActions from './iot-thing.actions';

export type ThingShadowRequestStatus = 'pending' | 'failed';

export interface ThingShadowRequest {
  status: ThingShadowRequestStatus;
  error?: unknown;
}

/**
 * Outstanding and failed shadow requests, keyed by thing name.  A thing with no
 * entry has either never been requested or has its shadow in the shadows slice.
 */
export interface State {
  [thingName: string]: ThingShadowRequest;
}

function setAll(state: State, thingNames: string[], request: ThingShadowRequest): State {
  return thingNames.reduce(
    (requests, thingName) => ({ ...requests, [thingName]: request }),
    state,
  );
}

export const reducer = createReducer<State>(
  {},
  on(IotThingActions.getThingShadow, (state, action): State =>
    setAll(state, [ action.thingName ], { status: 'pending' })),
  on(IotThingActions.getThingShadows, (state, action): State =>
    setAll(state, action.thingNames, { status: 'pending' })),
  on(IotThingActions.getThingShadowFailure, (state, action): State =>
    setAll(state, [ action.thingName ], { status: 'failed', error: action.error })),
  on(IotThingActions.getThingShadowsFailure, (state, action): State =>
    setAll(state, action.thingNames, { status: 'failed', error: action.error })),
  on(IotThingActions.upsertThingShadow, (state, action): State => {
    if (!state[action.thingName]) {
      return state;
    }

    const remaining = { ...state };
    delete remaining[action.thingName];
    return remaining;
  }),
);
